import { useAuth } from "#/feature/auth/auth-context";
import { Button } from "#/components/button/button";
import { WifiOff } from "lucide-react";
import {
  containerStyles,
  cardStyles,
  titleStyles,
  messageStyles,
  actionsStyles,
} from "./no-connection.css";

export function NoConnectionPage() {
  const { retryAuth, isLoading } = useAuth();

  return (
    <div className={containerStyles}>
      <div className={cardStyles}>
        <WifiOff size={48} strokeWidth={1.5} aria-hidden />
        <h1 className={titleStyles}>No connection!</h1>
        <p className={messageStyles}>
          Couldn&apos;t reach the server. Check your network and try again.
        </p>
        <div className={actionsStyles}>
          <Button onClick={() => void retryAuth()} disabled={isLoading} fullWidth>
            {isLoading ? "Retrying…" : "Retry"}
          </Button>
        </div>
      </div>
    </div>
  );
}
